import React from "react";
import moment from "moment";
import { useNavigate, Link, useParams } from "react-router-dom";
import { TailwindToaster } from "../../components";
import { toast } from "react-hot-toast";
import { useSelector } from "react-redux";
import Select from "react-select";

import axios from "../../api/axios";

const ServiceTaskCreate = () => {
  const state = useSelector((state) => state.UserReducer);
  const createUrl = "/servicetask";
  const serviceTicketsUrl = "/serviceticket/options";
  const activeUsersUrl = "/user/active";
  const navigate = useNavigate();
  const { serviceTicketId } = useParams();

  const [stateServiceTicketId, setStateServiceTicketId] =
    React.useState(serviceTicketId);
  const [serviceTicketsData, setServiceTicketsData] = React.useState([]);
  const [assigneeData, setAssigneeData] = React.useState([]);
  const [validTaskName, setTaskNameValidity] = React.useState(true);
  const [validServiceTicket, setServiceTicketValidity] = React.useState(true);
  const [requestLoading, setRequestLoading] = React.useState(false);

  const taskDueDate = moment().format("yyyy-MM-DD");
  const getAssigneeOptions = () => {
    try {
      axios
        .get(activeUsersUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.users?.length > 0) {
            setAssigneeData(response.data.users);
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const [pageTitle, setPageTitle] = React.useState("Task - Create");
  React.useEffect(() => {
    document.title = pageTitle;
  }, [pageTitle]);

  const getServiceTicketsOptions = () => {
    try {
      axios
        .get(serviceTicketsUrl, {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.serviceTickets?.length > 0) {
            // setServiceTicketsData(response.data.serviceTickets);
            const serviceTicketsOptionsData = [];
            response.data.serviceTickets.map((item) => {
              const recordTuple = {
                value: item._id,
                label:
                  "#" +
                  item.serviceTicketID +
                  " | " +
                  item?.addressBookId?.prefix +
                  ". " +
                  item?.addressBookId?.firstName +
                  " | " +
                  item?.serviceTypeId?.name +
                  " > " +
                  item?.subServiceTypeId?.name,
              };
              serviceTicketsOptionsData.push(recordTuple);
            });
            setServiceTicketsData(serviceTicketsOptionsData);
            // setTimeout(() => {
            //   if (stateServiceTicketId)
            //     document.getElementById("serviceTicketId").value =
            //       stateServiceTicketId;
            // }, 200);
            if (serviceTicketId) setStateServiceTicketId(serviceTicketId);
            getAssigneeOptions();
          }
        })
        .catch((err) => {
          toast.error("Something went wrong");
          console.log(err);
        });
    } catch (err) {
      toast.error("Something went wrong");
      console.log(err);
    }
  };

  const handleSubmit = (event) => {
    var canSubmit = true;
    const serviceTaskData = new FormData(event.target);

    setTaskNameValidity(true);
    setServiceTicketValidity(true);

    if (serviceTaskData.get("taskName") === "") {
      setTaskNameValidity(false);
      canSubmit = false;
    }
    if (stateServiceTicketId === "") {
      setServiceTicketValidity(false);
      canSubmit = false;
    }

    if (!canSubmit) {
      return;
    }
    setRequestLoading(true);
    const dataToSubmit = {
      serviceTicketId: stateServiceTicketId,
      name: serviceTaskData.get("taskName"),
      description: serviceTaskData.get("taskDescription"),
      dueDate: serviceTaskData.get("taskDueDate"),
      assignee: serviceTaskData.get("assigneeId"),
      status: serviceTaskData.get("taskStatus"),
    };

    try {
      axios
        .post(createUrl, JSON.stringify(dataToSubmit), {
          headers: {
            "Content-Type": "application/json",
            Authorization: state.user.token,
          },
        })
        .then((response) => {
          if (response?.data?.status === "success") {
            toast.success(response.data.message);
            setTimeout(() => {
              window.scrollTo(0, 0);
              navigate(-1);
            }, 1000);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch((err) => {
          toast.error(err.message);
        });
    } catch (err) {
      console.log(err);
      toast.error(err.message);
    } finally {
      setRequestLoading(false);
      //
    }
  };
  const onServiceTicketSelect = (selectedItem) => {
    setStateServiceTicketId(selectedItem.value);
  };

  React.useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
    getServiceTicketsOptions();
  }, []);

  return (
    <>
      <div className='min-h-full'>
        <main className='relative'>
          <div className='max-w-8xl mx-auto py-6 sm:px-6 lg:px-8'>
            <div className='px-4 py-0 sm:px-0'>
              <div className='block'>
                <form
                  action='#'
                  method='POST'
                  noValidate
                  onSubmit={(event) => {
                    event.preventDefault();
                    handleSubmit(event);
                  }}>
                  <TailwindToaster />
                  <div className='shadow overflow-hidden sm:rounded-md'>
                    <div className='px-4 py-5 bg-gray-50 sm:p-6'>
                      <div className='lg:flex lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <h2 className='text-xl font-semibold leading-3 text-gray-dark sm:text-xl '>
                            Create Service Task
                          </h2>
                        </div>
                      </div>
                      <div className='mt-4 sm:mt-4 grid grid-cols-12 gap-6'>
                        <div className='col-span-12 sm:col-span-3'>
                          <label
                            htmlFor='serviceTicketId'
                            className={`block text-sm font-medium ${
                              !validServiceTicket
                                ? "text-red-600"
                                : "text-gray-700"
                            }`}>
                            Service Ticket
                          </label>
                          <Select
                            className={`mt-1 text-sm block w-full bg-white rounded-md shadow-sm `}
                            theme={(theme) => ({
                              ...theme,
                              colors: {
                                ...theme.colors,
                                primary: "#f2b818",
                                primary50: "#f2b818",
                              },
                            })}
                            styles={{
                              control: (styles, state) => ({
                                ...styles,
                                border: !state.isFocused && "1px solid #6b7280",
                              }),
                              placeholder: (styles) => ({
                                ...styles,
                                color: "#6b7280",
                              }),
                              option: (baseStyles, data) => ({
                                ...baseStyles,
                                backgroundColor: "#fff",
                                color: "#000",
                                ":active": {
                                  ...baseStyles[":active"],
                                  backgroundColor: "#f2b818",
                                },
                                "&:hover": {
                                  backgroundColor: "#fcf2d4",
                                },
                              }),
                            }}
                            value={serviceTicketsData.filter(function (option) {
                              return option.value === stateServiceTicketId;
                            })}
                            onChange={onServiceTicketSelect}
                            isSearchable={true}
                            options={serviceTicketsData}
                            placeholder={"Select"}
                          />
                          {!validServiceTicket && (
                            <p className='text-red-600 text-sm'>
                              Service Ticket invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-12 sm:col-span-4'>
                          <label
                            htmlFor='taskName'
                            className={`block text-sm font-medium ${
                              !validTaskName ? "text-red-600" : "text-gray-700"
                            }`}>
                            Task Name*
                          </label>
                          <input
                            type='text'
                            name='taskName'
                            id='taskName'
                            maxLength='150'
                            className={`mt-1 ${
                              !validTaskName
                                ? "ring-red-800 focus:ring-red-800 border-red-800 focus:border-red-800"
                                : "focus:ring-yellow-2 focus:border-yellow-2"
                            }  block w-full shadow-sm sm:text-sm  rounded-md`}
                          />
                          {!validTaskName && (
                            <p className='text-red-600 text-sm'>
                              Task Name invalid
                            </p>
                          )}
                        </div>
                        <div className='col-span-4'></div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='taskDueDate'
                            className='block text-sm font-medium text-gray-700'>
                            Due Date*
                          </label>
                          <input
                            type='datetime-local'
                            name='taskDueDate'
                            id='taskDueDate'
                            defaultValue={taskDueDate}
                            min={taskDueDate}
                            className='mt-1 focus:ring-yellow-2 focus:border-yellow-2 block w-full shadow-sm sm:text-sm  rounded-md'
                          />
                        </div>
                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='assigneeId'
                            className='block text-sm font-medium text-gray-700'>
                            Assignee
                          </label>
                          <select
                            id='assigneeId'
                            name='assigneeId'
                            className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option value=''>Unassigned</option>
                            {assigneeData.length > 0 ? (
                              assigneeData.map((item) => {
                                return (
                                  <option key={item?._id} value={item?._id}>
                                    {item.fullname
                                      ? item.fullname
                                      : item.firstname}
                                  </option>
                                );
                              })
                            ) : (
                              <option key='1' value=''>
                                Loading...
                              </option>
                            )}
                          </select>
                          <span
                            className='block text-sm font-semibold text-yellow-2 cursor-pointer'
                            onClick={(e) => {
                              document.getElementById("assigneeId").value =
                                state.user._id;
                            }}>
                            Assign to me
                          </span>
                        </div>

                        <div className='col-span-6 sm:col-span-2'>
                          <label
                            htmlFor='taskStatus'
                            className='block text-sm font-medium text-gray-700'>
                            Status
                          </label>
                          <select
                            id='taskStatus'
                            name='taskStatus'
                            className='mt-1 block w-full py-2 px-3 border  bg-white rounded-md shadow-sm focus:outline-none focus:ring-yellow-2 focus:border-yellow-2 sm:text-sm'>
                            <option>NEW</option>
                            <option>ASSIGNED</option>
                            <option vaule='IN-PROCESS'>IN-PROCESS</option>
                          </select>
                        </div>
                        <div className='col-span-5'></div>
                        <div className='col-span-12 sm:col-span-7'>
                          <label
                            htmlFor='taskDescription'
                            className='block text-sm font-semibold text-gray'>
                            Task Description
                          </label>
                          <textarea
                            id='taskDescription'
                            name='taskDescription'
                            rows={4}
                            className='shadow-sm focus:ring-yellow-2 focus:border-yellow-2 mt-1 block w-full sm:text-sm border bg-gray-50 rounded-md'
                            placeholder=''
                            defaultValue={""}
                          />
                        </div>
                      </div>
                    </div>
                    <div className='px-4 py-3 bg-gray-50 text-right sm:px-6'>
                      <div className='lg:flex lg:items-center justify-between'>
                        <div className='flex-1 min-w-0 px-0 lg:px-0'>
                          <Link
                            to='#'
                            onClick={(e) => {
                              e.preventDefault();
                              navigate(-1);
                            }}
                            className='inline-flex justify-center py-2 px-4 border-yellow-2 border shadow-sm text-sm font-medium rounded-sm text-yellow-2 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                            Back
                          </Link>
                          {!requestLoading ? (
                            <button
                              id='submitBtn'
                              type='submit'
                              className='ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2 hover:bg-gray-dark duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'>
                              SAVE
                            </button>
                          ) : (
                            <button
                              className='animate-bounce ml-2 inline-flex justify-center py-2 px-4 border-transparent shadow-sm text-sm font-medium rounded-sm text-white bg-yellow-2  duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-yellow-2'
                              disabled={true}>
                              Processing...
                            </button>
                          )}
                        </div>
                      </div>
                      <div className='sm: py-2'></div>
                    </div>
                  </div>
                </form>
              </div>
              <div className='block md:hidden'>
                <div className='grid grid-cols-1 gap-4'></div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default ServiceTaskCreate;
